module.exports = __webpack_public_path__ + "img/amtl-europa-creativa.467dfd95.png";